module.exports = __webpack_public_path__ + "img/sloth-bicycle-foreground.ecd1845.png";